<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()" *ngIf="!currentUrl">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title [ngClass]="{'ion-title-icon': userProvider.isAdmOracao()}" *ngIf="!userProvider.hasConfig(184)">
      {{'oracao' | nomenclatura | async}}
    </ion-title>

    <ion-title [ngClass]="{'ion-title-icon': userProvider.isAdmOracao()}" *ngIf="userProvider.hasConfig(184)">
      {{(getNomenclatura(tipo) | nomenclatura | async)}}
    </ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content class="schedule-content" *ngIf="loaded">
  <div class="gradient-extendido" *ngIf="tipo == '0' || (tipo === '1' && userProvider.isAdmOracao())">
    <div class="principal">
      <ion-segment
        mode="ios"
        value="oracao"
        class="segment-gradient-title"
        [(ngModel)]="tipoSegment"
        (ionChange)="onSegmentChanged($event)"
        [scrollable]="true"
      >
        <ion-segment-button value="oracao">
          <ion-label class="header">{{'oracoes' | nomenclatura | async}}</ion-label>
        </ion-segment-button>

        <ion-segment-button value="testemunho" *ngIf="tipo != '1'">
          <ion-label class="header">{{'testemunhos' | nomenclatura | async}}</ion-label>
        </ion-segment-button>

        <ion-segment-button value="gerenciar" *ngIf="userProvider.isAdmOracao()">
          <ion-label class="header">
            {{'Gerenciar' | translate}}
            <ion-badge [hidden]="paginationOracao.totalPendente == 0" id="notifications-badge" color="danger">
              <div class="badge-div"></div>
            </ion-badge>
          </ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
  </div>

  <div class="gradient-extendido" *ngIf="tipo == '2' && userProvider.isAdmOracao()">
    <div class="principal">
      <ion-segment
        mode="ios"
        value="testemunho"
        class="segment-gradient-title"
        [(ngModel)]="tipoSegment"
        (ionChange)="onSegmentChanged($event)"
        [scrollable]="true"
      >
        <ion-segment-button value="testemunho">
          <ion-label class="header">{{'testemunhos' | nomenclatura | async}}</ion-label>
        </ion-segment-button>

        <ion-segment-button value="gerenciar" *ngIf="userProvider.isAdmOracao()">
          <ion-label class="header">
            {{'Gerenciar' | translate}}
            <ion-badge [hidden]="paginationOracao.totalPendente == 0" id="notifications-badge" color="danger">
              <div class="badge-div"></div>
            </ion-badge>
          </ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
  </div>

  <div [ngSwitch]="tipoSegment" *ngIf="loaded">
    <ion-list *ngSwitchCase="'oracao'" class="switch-segment remove-border ion-margin-top" slot="start">
      <ion-item *ngIf="loaded" class="switch-item">
        <ion-select
          interface="popover"
          [(ngModel)]="oracaoTipo"
          (ionChange)="onSegmentChanged($event)"
          class="custom-select font-desc"
        >
          <ion-select-option value="publicosOracao" class="font-desc">
            {{'Todas ' | translate}} {{'oracoes' | nomenclatura | async}}
          </ion-select-option>

          <ion-select-option value="meusOracao" class="font-desc">
            {{'Minhas ' | translate}} {{'oracoes' | nomenclatura | async}}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>

    <!-- Testemunho -->
    <ion-list *ngSwitchCase="'testemunho'" class="switch-segment remove-border ion-margin-top" slot="start">
      <ion-item *ngIf="loaded && tipo =='0' || tipo =='2'" class="switch-item">
        <ion-select
          interface="popover"
          [(ngModel)]="testemunhoTipo"
          (ionChange)="onSegmentChanged($event)"
          class="custom-select"
        >
          <ion-select-option value="publicosTestemunhos" class="header">
            {{'Todos ' | translate}} {{'testemunhos' | nomenclatura | async}}
          </ion-select-option>

          <ion-select-option value="meusTestemunhos" class="header">
            {{'Meus ' | translate}} {{'testemunhos' | nomenclatura | async}}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
  </div>

  <!-- Testemunho -->
  <div [ngSwitch]="testemunhoTipo" *ngIf="loaded && tipoSegment == 'testemunho'">
    <div *ngSwitchCase="'publicosTestemunhos'">
      <div class="gradient-extendido-div">
        <div *ngFor="let oracao of testemunhoList">
          <ion-grid>
            <ion-row>
              <ion-col size="12">
                <ion-row>
                  <ion-col class="remove-border">
                    <ion-item>
                      <ion-avatar slot="start">
                        <img src="{{oracao.pessoa.foto | image:' '}}" class="avatar-image" />
                      </ion-avatar>

                      <ion-label>
                        <h2 class="nome-usuario">{{oracao.pessoa.nome}}</h2>

                        <p class="dias">{{'há ' | translate}} {{getFromNow(oracao.data)}}</p>
                      </ion-label>
                    </ion-item>
                  </ion-col>
                </ion-row>

                <ion-card class="top-card-all">
                  <ion-grid>
                    <ion-row class="down-card ion-row-bord">
                      <ion-col class="remove-border">
                        <ion-item>
                          <ion-label>
                            <p class="pedido">{{oracao.pedido}}</p>
                          </ion-label>
                        </ion-item>
                      </ion-col>
                    </ion-row>

                    <ion-row class="ion-padding-start">
                      <ion-col *ngIf="oracao.idOracaoTestemunho">
                        <ion-button class="text" shape="round" fill="outline" (click)="testemunhoOracao(oracao, false)">
                          {{'Oracao' | nomenclatura | async}}
                        </ion-button>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-card>

                <ion-row>
                  <ion-col size="4">
                    <div class="oracao-nok" (click)="oreiPorVoce(oracao)">
                      <i *ngIf="!oracao.userOrei" class="fa-light fa-heart"></i>
                      <i *ngIf="oracao.userOrei" class="fa-solid fa-heart"></i>
                      <p class="desc-oracao">{{'Orei por Você' | translate}}</p>
                    </div>
                  </ion-col>

                  <ion-col size="8" class="ion-text-end ion-padding-end" *ngIf="oracao.total > 0">
                    <p class="text" *ngIf="oracao.total == 1">
                      {{oracao.total}} {{'Pessoa(s) orou por esse pedido' | translate}}
                    </p>
                    <p class="text" *ngIf="oracao.total > 1">
                      {{oracao.total}} {{'Pessoa(s) oraram por esse pedido' | translate}}
                    </p>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </div>

      <ion-infinite-scroll
        [hidden]="!testemunhoList.length"
        (ionInfinite)="loadTestemunhos($event)"
        *ngIf="paginationTestemunhos.currentPage < paginationTestemunhos.pageCount"
      >
        <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
      </ion-infinite-scroll>

      <sem-registro *ngIf="!testemunhoList.length"></sem-registro>

      <ion-grid>
        <ion-row class="ion-justify-content-start">
          <ion-col>
            <div class="pd-5">
              <ion-button expand="block" class="btn-default" (click)="novoPedido(true)">
                {{'Envie seu ' | translate}}{{'testemunho' | nomenclatura | async}}
              </ion-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div *ngSwitchCase="'meusTestemunhos'">
      <div class="gradient-extendido-div">
        <div [hidden]="!meusTestemunhosList.length" *ngFor="let oracao of meusTestemunhosList">
          <ion-grid>
            <ion-row>
              <ion-col size="12">
                <ion-card class="top-card-me">
                  <ion-grid>
                    <ion-row>
                      <ion-col class="remove-border">
                        <ion-item>
                          <ion-label>
                            <h2 class="nome-usuario">
                              {{oracao.privacidade == 'PUBLICO' ? ('Público' | translate) : ('Privado' | translate)}}
                            </h2>

                            <p class="dias">{{ oracao.data | dateFormat: "mediaHora" }}</p>
                          </ion-label>
                          <i class="fa-solid fa-ellipsis-vertical" slot="end" [id]="'popover-button-' + oracao.id"></i>
                        </ion-item>
                      </ion-col>
                    </ion-row>

                    <ion-row class="down-card-me">
                      <ion-col class="remove-border">
                        <ion-item>
                          <ion-label>
                            <p class="pedido">
                              <span class="bold-1"> {{oracao.pedido}} </span>
                            </p>
                          </ion-label>
                        </ion-item>

                        <ion-popover [trigger]="'popover-button-' + oracao.id" [dismissOnSelect]="true">
                          <ng-template>
                            <ion-list>
                              <ion-item class="text" [button]="true" [detail]="false" (click)="opcoesMinhas(oracao)"
                                >{{'Cancelar ' | translate}} {{'testemunho' | nomenclatura | async}}</ion-item
                              >
                            </ion-list>
                          </ng-template>
                        </ion-popover>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-card>

                <ion-row>
                  <ion-col (click)="pessoasOracao(oracao.id, true);" *ngIf="oracao.total > '0'">
                    <ion-label class="respostas">
                      {{oracao.total}} {{'pessoa(s) orando por você' | translate}}!
                    </ion-label>
                  </ion-col>
                </ion-row>

                <ion-row>
                  <ion-col *ngIf="oracao.hasResposta" (click)="respostas(oracao);">
                    <ion-label class="respostas"> {{'Visualizar resposta' | translate}} </ion-label>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </div>

      <sem-registro *ngIf="!meusTestemunhosList.length"></sem-registro>

      <ion-grid>
        <ion-row class="ion-justify-content-start">
          <ion-col>
            <div class="pd-5">
              <ion-button expand="block" class="btn-default" (click)="novoPedido(true)">
                {{'Envie seu ' | translate}}{{'testemunho' | nomenclatura | async}}
              </ion-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>

  <div [ngSwitch]="oracaoTipo" *ngIf="loaded && tipoSegment == 'oracao'">
    <div *ngSwitchCase="'publicosOracao'">
      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-praying-hands div-icon"></i>
          </ion-note>

          <ion-label class="color-title"> {{'Todas as ' | translate}} {{'oracoes' | nomenclatura | async}} </ion-label>
        </div>

        <div *ngFor="let oracao of oracaoList">
          <ion-grid>
            <ion-row>
              <ion-col size="12">
                <ion-card class="top-card-all">
                  <ion-grid>
                    <ion-row class="ion-row-bord">
                      <ion-col class="remove-border">
                        <ion-item>
                          <ion-avatar slot="start">
                            <img src="{{oracao.pessoa.foto | image:' '}}" class="avatar-image" />
                          </ion-avatar>

                          <ion-label>
                            <h2 class="nome-usuario">{{oracao.pessoa.nome}}</h2>

                            <p class="dias">
                              <span>{{getFromNow(oracao.data)}}</span>
                            </p>
                          </ion-label>
                        </ion-item>
                      </ion-col>
                    </ion-row>

                    <ion-row class="down-card">
                      <ion-col class="remove-border">
                        <ion-item>
                          <ion-label>
                            <p class="pedido">
                              <span> {{oracao.pedido}} </span>
                            </p>
                          </ion-label>
                        </ion-item>
                      </ion-col>
                    </ion-row>

                    <ion-row class="ion-padding-start">
                      <ion-col *ngIf="oracao.idTestemunho" class="slot-end">
                        <ion-button class="text" shape="round" fill="outline" (click)="testemunhoOracao(oracao, true)">
                          {{'Testemunho' | nomenclatura | async}}
                        </ion-button>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-card>

                <ion-row>
                  <ion-col size="4">
                    <div class="oracao-nok" (click)="oreiPorVoce(oracao)">
                      <i *ngIf="!oracao.userOrei" class="fa-light fa-heart"></i>
                      <i *ngIf="oracao.userOrei" class="fa-solid fa-heart"></i>
                      <p class="desc-oracao">{{'Orei por Você' | translate}}</p>
                    </div>
                  </ion-col>

                  <ion-col class="ion-text-end ion-padding-end" size="8" *ngIf="oracao.total > 0">
                    <p class="text" *ngIf="oracao.total == 1">
                      {{oracao.total}} {{'Pessoa(s) orou por esse pedido' | translate}}
                    </p>
                    <p class="text" *ngIf="oracao.total > 1">
                      {{oracao.total}} {{'Pessoa(s) oraram por esse pedido' | translate}}
                    </p>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </div>

      <ion-infinite-scroll
        [hidden]="!oracaoList.length"
        (ionInfinite)="loadOracoes($event)"
        *ngIf="paginationOracao.currentPage < paginationOracao.pageCount"
      >
        <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
      </ion-infinite-scroll>

      <sem-registro *ngIf="!oracaoList.length"></sem-registro>

      <ion-grid style="margin: 40px 0">
        <ion-row class="ion-justify-content-center">
          <ion-col size="11">
            <div>
              <ion-button expand="block" class="btn-default" (click)="novoPedido(false)">
                {{'Novo pedido de ' | translate}}{{'oracao' | nomenclatura | async}}
              </ion-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div *ngSwitchCase="'meusOracao'">
      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-praying-hands div-icon"></i>
          </ion-note>

          <ion-label class="color-title"> {{'Minhas ' | translate}} {{'oracoes' | nomenclatura | async}} </ion-label>
        </div>

        <div *ngIf="minhasOracaoList.length">
          <ion-grid *ngFor="let oracao of minhasOracaoList">
            <ion-row>
              <ion-col size="12">
                <ion-card class="top-card-me">
                  <ion-grid>
                    <ion-row>
                      <ion-col class="remove-border">
                        <ion-item>
                          <ion-label>
                            <h2 class="nome-usuario">
                              {{oracao.privacidade == 'PUBLICO' ? ('Público' | translate) : ('Privado' | translate)}}
                            </h2>

                            <p class="dias">
                              <span>{{ oracao.data | dateFormat: "mediaHora" }} </span>
                            </p>
                          </ion-label>

                          <ion-icon slot="end" [id]="'popover-button-' + oracao.id" name="ellipsis-vertical"></ion-icon>
                        </ion-item>
                      </ion-col>
                    </ion-row>

                    <ion-row class="down-card-me">
                      <ion-col class="remove-border">
                        <ion-item>
                          <ion-label>
                            <div>
                              <p class="pedido">
                                <span class="bold-1"> {{oracao.pedido}} </span>
                              </p>
                            </div>
                          </ion-label>
                        </ion-item>

                        <ion-popover [trigger]="'popover-button-' + oracao.id" [dismissOnSelect]="true">
                          <ng-template>
                            <ion-list>
                              <ion-item
                                class="text"
                                [button]="true"
                                [detail]="false"
                                (click)="privacidade(oracao, oracao.isTestemunho);"
                              >
                                {{'Alterar Privacidade' | translate}}
                                <i
                                  *ngIf="oracao.privacidade == 'PRIVADO'"
                                  class="fas fa-lock-alt icon-button"
                                  slot="end"
                                ></i>
                                <i
                                  *ngIf="oracao.privacidade == 'PUBLICO'"
                                  class="fa-solid fa-lock-open icon-button"
                                  slot="end"
                                ></i>
                              </ion-item>

                              <ion-item class="text" [button]="true" [detail]="false" (click)="opcoesMinhas(oracao)"
                                >{{'Cancelar ' | translate}} {{'oracao' | nomenclatura | async}}</ion-item
                              >
                            </ion-list>
                          </ng-template>
                        </ion-popover>

                        <ion-button
                          expand="block"
                          class="btn-custom-icon"
                          [disabled]="oracao.idTestemunho"
                          (click)="testemunhar(oracao);"
                        >
                          <ion-icon *ngIf="!oracao.idTestemunho" slot="start" name="heart" class="heart"></ion-icon>

                          <div *ngIf="!oracao.idTestemunho">{{'Testemunhar' | translate}}</div>

                          <div *ngIf="oracao.idTestemunho">{{'Testemunho Realizado' | translate}}</div>
                        </ion-button>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-card>

                <ion-row>
                  <ion-col class="oracao-nok" *ngIf="oracao.total > 0">
                    <div (click)="pessoasOracao(oracao.id, false);">
                      <p class="text ion-no-margin">{{oracao.total}} {{'Pessoa(s) orando por você' | translate}}</p>
                    </div>
                  </ion-col>
                </ion-row>

                <div *ngIf="oracao.hasResposta" (click)="respostas(oracao);">
                  <ion-label class="respostas"> {{'Visualizar resposta' | translate}} </ion-label>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </div>

      <ion-infinite-scroll
        [hidden]="!minhasOracaoList.length"
        (ionInfinite)="loadMinhasOracoes($event)"
        *ngIf="paginationMeusOracao.currentPage < paginationMeusOracao.pageCount"
      >
        <ion-infinite-scroll-content loadingText="(Carregando | translate) ..."> </ion-infinite-scroll-content>
      </ion-infinite-scroll>

      <sem-registro *ngIf="!minhasOracaoList.length"></sem-registro>

      <ion-grid style="margin: 40px 0">
        <ion-row class="ion-justify-content-center">
          <ion-col size="11">
            <div>
              <ion-button expand="block" class="btn-default" (click)="novoPedido(false)">
                {{'Novo pedido de ' | translate}}{{'oracao' | nomenclatura | async}}
              </ion-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>

  <div [ngSwitch]="tipoSegment">
    <div *ngSwitchCase="'gerenciar'">
      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-cog div-icon"></i>
          </ion-note>

          <ion-label class="color-title" *ngIf="!userProvider.hasConfig(184)">
            {{'Administrar ' | translate}} {{'oracoes' | nomenclatura | async}}
          </ion-label>

          <ion-label class="color-title" *ngIf="userProvider.hasConfig(184)">
            {{'Administrar ' | translate}} {{(getNomenclatura(tipo) | nomenclatura | async)}}
          </ion-label>

          <ion-note slot="end">
            <i class="fa fa-filter filter" (click)="filtroMensagem();"></i>
          </ion-note>
        </div>

        <ion-grid *ngFor="let oracao of oracoes">
          <ion-row>
            <ion-col size="12">
              <ion-card class="top-card-all">
                <ion-grid>
                  <ion-row class="ion-row-bord">
                    <ion-col class="remove-border">
                      <ion-item>
                        <ion-avatar slot="start">
                          <img src="{{oracao.pessoa.foto | image:' '}}" class="avatar-image" />
                        </ion-avatar>

                        <ion-label>
                          <h2 class="nome-usuario" style="color: black">{{oracao.pessoa.nome}}</h2>

                          <p class="dias">{{ oracao.data | dateFormat:"mediaHora" }}</p>
                        </ion-label>

                        <ion-note slot="end" (click)="opcoesAdm(oracao)">
                          <i class="fa-solid fa-ellipsis-vertical"></i>
                        </ion-note>
                      </ion-item>
                    </ion-col>
                  </ion-row>

                  <ion-row class="ion-margin-start ion-margin-top">
                    <ion-col size="auto">
                      <ion-badge class="badge-size" color="tertiary">
                     {{ oracao.formaPedido === 'SISTEMA' ? ('Sistema' | translate) : 
                        oracao.formaPedido === 'APLICATIVO' ? ('Aplicativo' | translate) : 
                        oracao.formaPedido === 'SITE' ? ('Site' | translate) : ''
                      }}
                      </ion-badge>
                    </ion-col>

                    <ion-col size="auto" *ngIf="oracao.privacidade">
                      <ion-badge class="badge-size" [color]="oracao.privacidade === 'PUBLICO' ? 'danger' : 'danger'">
                        {{ oracao.privacidade === 'PUBLICO' ? ('Público' | translate) : ('Privado' | translate) }}
                      </ion-badge>
                    </ion-col>

                    <ion-col size="auto">
                      <ion-badge class="badge-size" [color]="oracao.isTestemunho === '1' ? 'success' : 'secondary'">
                        {{ oracao.isTestemunho === '1' ? 'Testemunho' : (('oracao' | nomenclatura | async) || 'Oração')
                        }}
                      </ion-badge>
                    </ion-col>
                  </ion-row>

                  <ion-row>
                    <ion-col class="ion-margin-start">
                      <p class="font-desc">{{oracao.pedido}}</p>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>

              <ion-row class="remove-border ion-align-items-center" *ngIf="oracao.privacidade == 'PUBLICO'">
                <ion-col size="8" class="display-center">
                  <p class="text">{{'Liberar para listagem pública' | translate}}?</p>
                </ion-col>

                <ion-col class="display-center" size="4">
                  <ion-toggle [enableOnOffLabels]="true" id="bg" (ionChange)="mudarPublico(oracao)" [checked]="oracao.liberado == '1'">
                  </ion-toggle>
                </ion-col>
              </ion-row>
              <ion-row class="ion-justify-content-center">
                <ion-col size="5">
                  <ion-button
                    expand="block"
                    fill="outline"
                    class="font-desc btn-danger"
                    (click)="excluirOracao(oracao)"
                  >
                    <div>{{'Excluir' | translate}}</div>
                  </ion-button>
                </ion-col>

                <ion-col size="5" *ngIf="oracao.status == '1'">
                  <ion-button expand="block" class="btn-default font-desc" (click)="responder(oracao);">
                    <div>{{'Responder' | translate}}</div>
                  </ion-button>
                </ion-col>

                <ion-col size="5" *ngIf="oracao.status == '2'">
                  <ion-button expand="block" class="btn-success font-desc" (click)="responder(oracao);">
                    <ion-icon class="icon-space" name="checkmark-circle"></ion-icon>
                    <div>{{'Respondido' | translate}}</div>
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </ion-grid>

        <sem-registro *ngIf="!oracoes.length"></sem-registro>

        <ion-infinite-scroll (ionInfinite)="loadOracoes($event)" *ngIf="pagination.currentPage < pagination.pageCount">
          <ion-infinite-scroll-content loadingText="(Carregando | translate)..."> </ion-infinite-scroll-content>
        </ion-infinite-scroll>

        <ion-grid>
          <ion-row class="ion-justify-content-center">
            <ion-col size="11">
              <div>
                <ion-button
                  expand="block"
                  class="btn-default"
                  (click)="openNova(null)"
                  *ngIf="!userProvider.hasConfig(184)"
                >
                  {{'Novo pedido de ' | translate}}{{'oracao' | nomenclatura | async}} / {{'testemunho' | nomenclatura |
                  async}}
                </ion-button>

                <ion-button
                  expand="block"
                  class="btn-default"
                  (click)="openNova(null)"
                  *ngIf="userProvider.hasConfig(184)"
                >
                  {{'Novo pedido de ' | translate}}{{(getNomenclatura(tipo) | nomenclatura | async)}}
                </ion-button>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>

  <ion-fab slot="fixed" vertical="bottom" horizontal="end" *ngIf="btnMultigreja">
    <ion-fab-button (click)="showFilterInstituicao()" class="btn-filtro-instituicao">
      <i class="fas fa-place-of-worship"></i>
    </ion-fab-button>
  </ion-fab>
</ion-content>
